import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "schedule-list" }
const _hoisted_2 = { class: "subpage" }

import UsualScheduleSubpage from './Subpages/UsualScheduleSubpage/UsualScheduleSubpage.vue';
import ModifiedScheduleSubpage from './Subpages/ModifiedScheduleSubpage/ModifiedScheduleSubpage.vue';
import TabMenu from '@/common/components/snedson-material-components/tab-menu/tab-menu.vue';
import { reactive } from 'vue';
import { ScheduleSubpage } from './SchedulePage.types';
import router from '@/router';
import { HandleAnimation } from '@/services/animation-service';
import { animationState } from '@/services/animation-service/animation-state.ts';


export default /*#__PURE__*/_defineComponent({
  __name: 'SchedulePage',
  setup(__props) {

const state = reactive<{ selectTabId: number }>({
    selectTabId: ScheduleSubpage.Modified,
});

const selectTab = (tabId: number) => {
    animationState.flow = HandleAnimation('horizontal', state.selectTabId, tabId);
    state.selectTabId = tabId;
    
    if (tabId == ScheduleSubpage.Modified) {
        router.push({ name: 'sn.student.schedule.mse' });
    } else {
        router.push({ name: 'sn.student.schedule.use' });
    }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TabMenu, {
      props: {
                tabs: [
                    { id: _unref(ScheduleSubpage).Modified, title: 'Изменённое' },
                    { id: _unref(ScheduleSubpage).Usual, title: 'Стандартное' },
                ],
                selectedTabItemId: _unref(ScheduleSubpage).Modified,
            },
      onChange: selectTab
    }, null, 8, ["props"]),
    _createElementVNode("div", _hoisted_2, [
      (state.selectTabId === _unref(ScheduleSubpage).Modified)
        ? (_openBlock(), _createBlock(ModifiedScheduleSubpage, { key: 0 }))
        : (state.selectTabId === _unref(ScheduleSubpage).Usual)
          ? (_openBlock(), _createBlock(UsualScheduleSubpage, { key: 1 }))
          : _createCommentVNode("", true)
    ])
  ]))
}
}

})